var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolarDollarBoldBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:dollar-bold"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 101",
    cx: 12.625,
    cy: 12.5,
    r: 9.375,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8438 8.17383C10.8687 8.44049 10.2812 9.18945 10.2812 9.8957C10.2812 10.602 10.8687 11.3509 11.8438 11.6165V8.17383ZM13.4062 13.3832V16.8249C14.3812 16.5592 14.9688 15.8103 14.9688 15.104C14.9688 14.3978 14.3812 13.6488 13.4062 13.3832Z",
    fill: "#eb2426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0404 12.5007C23.0404 18.2538 18.3768 22.9173 12.6237 22.9173C6.87057 22.9173 2.20703 18.2538 2.20703 12.5007C2.20703 6.74753 6.87057 2.08398 12.6237 2.08398C18.3768 2.08398 23.0404 6.74753 23.0404 12.5007ZM12.6237 5.4694C12.8309 5.4694 13.0296 5.55171 13.1761 5.69822C13.3226 5.84474 13.4049 6.04345 13.4049 6.25065V6.58086C15.1029 6.88503 16.5299 8.16107 16.5299 9.89648C16.5299 10.1037 16.4476 10.3024 16.3011 10.4489C16.1546 10.5954 15.9559 10.6777 15.7487 10.6777C15.5415 10.6777 15.3428 10.5954 15.1963 10.4489C15.0498 10.3024 14.9674 10.1037 14.9674 9.89648C14.9674 9.19023 14.3799 8.44128 13.4049 8.17461V11.7892C15.1029 12.0934 16.5299 13.3694 16.5299 15.1048C16.5299 16.8402 15.1029 18.1163 13.4049 18.4204V18.7507C13.4049 18.9579 13.3226 19.1566 13.1761 19.3031C13.0296 19.4496 12.8309 19.5319 12.6237 19.5319C12.4165 19.5319 12.2178 19.4496 12.0713 19.3031C11.9248 19.1566 11.8424 18.9579 11.8424 18.7507V18.4204C10.1445 18.1163 8.71745 16.8402 8.71745 15.1048C8.71745 14.8976 8.79976 14.6989 8.94627 14.5524C9.09278 14.4059 9.2915 14.3236 9.4987 14.3236C9.7059 14.3236 9.90461 14.4059 10.0511 14.5524C10.1976 14.6989 10.2799 14.8976 10.2799 15.1048C10.2799 15.8111 10.8674 16.56 11.8424 16.8257V13.2121C10.1445 12.9079 8.71745 11.6319 8.71745 9.89648C8.71745 8.16107 10.1445 6.88503 11.8424 6.58086V6.25065C11.8424 6.04345 11.9248 5.84474 12.0713 5.69822C12.2178 5.55171 12.4165 5.4694 12.6237 5.4694Z",
    fill: "#eb2426"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarDollarBoldBg);
export default __webpack_public_path__ + "static/media/solar_dollar-bold-bg.52ff956c32bc28559cd2399349532ba9.svg";
export { ForwardRef as ReactComponent };